import React, { Component } from 'react';
import HeaderPage from '../projectmgmt/header/Header';
import TtsLeftPanel from './TtsLeftPanel';

class TtsMainPage extends Component {
  render() {
    return (
      <div style={{ backgroundColor: '#F9F9FB' }}>
        {/* Navbar */}
        <div id="navBar">
          <HeaderPage />
        </div>
        {/* Left panel */}
        <div className="content-wrapper" id="leftPanel" >
          <TtsLeftPanel />
        </div>
      </div>
    );
  }
}

export default TtsMainPage;


// WEBPACK FOOTER //
// ./src/ttsUi/TtsMainPage.js